(ns practitest.frontend.integration-settings.auto-sync-filters.events
  (:require [re-frame.core :as re-frame]
            [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.notifications :as notifications]))

(def db-key :auto-sync-filters)

(def ^:private mixpanel-event "Jira Auto Sync Filters")

(defn- track-fx [action]
  [[::mixpanel/track [mixpanel-event {"Action" action}]]])

(defn- empty-row [current-user-id current-user-name]
  { :filter-id     ""
    :filter-target ""
    :filter-name   ""
    :user-id       current-user-id
    :user-name     current-user-name
    :last-sync     ""
    :editable      true})

(re-frame/reg-event-fx
  ::initialize-db
  (fn [{:keys [db]} [_ config]]
    (let [rows (vec (:rows config []))]
      {:db (assoc db db-key
                  { :rows               rows
                    :saved-rows         rows
                    :all-filters        (vec (:all-filters config []))
                    :sync-interval      (:sync-interval config "")
                    :current-user-id    (:current-user-id config)
                    :current-user-name  (:current-user-name config "")
                    :warnings           (:warnings config [])
                    :save-url           (:save-url config "")
                    :cancel-url         (:cancel-url config "")
                    :tabs               (:tabs config [])
                    :active-tab         (:active-tab config "")
                    :bugtracker-label   (:bugtracker-label config "")
                    :identifier         (:identifier config "")
                    :saving?            false
                    :changes-made?      false})
       :fx (track-fx "Auto Sync Filters Opened")})))

(re-frame/reg-event-fx
  ::add-row
  (fn [{:keys [db]} _]
    (let [current-user-id   (get-in db [db-key :current-user-id])
          current-user-name (get-in db [db-key :current-user-name])]
      {:db (-> db
               (update-in [db-key :rows] conj (empty-row current-user-id current-user-name))
               (assoc-in [db-key :changes-made?] true))
       :fx (track-fx "Filter Row Added")})))

(re-frame/reg-event-fx
  ::remove-row
  (fn [{:keys [db]} [_ idx]]
    (let [rows     (get-in db [db-key :rows])
          new-rows (vec (concat (subvec rows 0 idx) (subvec rows (inc idx))))]
      {:db (-> db
               (assoc-in [db-key :rows] new-rows)
               (assoc-in [db-key :changes-made?] true))
       :fx (track-fx "Filter Row Deleted")})))

(re-frame/reg-event-db
  ::set-filter
  (fn [db [_ idx filter-id]]
    (let [all-filters (get-in db [db-key :all-filters] [])
          label       (:label (first (filter #(= (:id %) filter-id) all-filters)) "")]
      (-> db
          (assoc-in [db-key :rows idx :filter-id] filter-id)
          (assoc-in [db-key :rows idx :filter-name] label)
          (assoc-in [db-key :changes-made?] true)))))

(re-frame/reg-event-db
  ::set-target
  (fn [db [_ idx target]]
    (-> db
        (assoc-in [db-key :rows idx :filter-target] target)
        (assoc-in [db-key :changes-made?] true))))

(defn- row->payload [row]
  { "filter_id"     (:filter-id row "")
    "filter_target" (:filter-target row "")
    "filter_name"   (:filter-name row "")
    "user_id"       (:user-id row)})

(defn- validate-rows [rows]
  (vec (distinct
         (reduce
           (fn [errors row]
             (cond
               (not (:editable row))
               errors

               (str/blank? (:filter-id row))
               (conj errors (get-translation "jira-auto-sync-filters.validation.filter-blank"
                                             "Jira Filter can't be blank."))

               (str/blank? (:filter-target row))
               (conj errors (get-translation "jira-auto-sync-filters.validation.entity-blank"
                                             "PractiTest entities can't be blank."))

               :else errors))
           []
           rows))))

(re-frame/reg-event-fx
  ::save
  (fn [{:keys [db]} _]
    (let [state    (get db db-key)
          rows     (:rows state [])
          save-url (:save-url state "")
          errors   (validate-rows rows)]
      (if (seq errors)
        {:fx (mapv (fn [err] [:dispatch [::notifications/error2 err]]) errors)}
        {:db         (assoc-in db [db-key :saving?] true)
         :http-xhrio {:method          :post
                      :uri             save-url
                      :params          {:filters (mapv row->payload rows)}
                      :format          (ajax/json-request-format)
                      :response-format (ajax/raw-response-format)
                      :on-success      [::save-success]
                      :on-failure      [::save-failure]}}))))

(re-frame/reg-event-fx
  ::save-success
  (fn [{:keys [db]} _]
    (let [rows (get-in db [db-key :rows])
          synced-filter-names (set (map :filter-name rows))]
      {:db (-> db
               (assoc-in [db-key :saving?] false)
               (assoc-in [db-key :saved-rows] rows)
               (update-in [db-key :warnings] #(filterv synced-filter-names %))
               (assoc-in [db-key :changes-made?] false))
       :fx (conj (track-fx "Settings Updated")
                 [:dispatch [::notifications/success2
                            (get-translation "jira-auto-sync-filters.updated-successfully"
                                             "Successfully updated synced Jira filters!")]])})))

(re-frame/reg-event-fx
  ::save-failure
  (fn [{:keys [db]} _]
    {:db (assoc-in db [db-key :saving?] false)
     :fx [[:dispatch [::notifications/error2
                      (get-translation "jira-auto-sync-filters.save-failed"
                                       "Failed to update synced Jira filters")]]]}))

(re-frame/reg-event-fx
  ::cancel
  (fn [{:keys [db]} _]
    {:db (-> db
             (assoc-in [db-key :rows] (get-in db [db-key :saved-rows]))
             (assoc-in [db-key :changes-made?] false))
     :fx (track-fx "Settings Cancelled")}))
